module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "showClose": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true,
      "autoFocusField": false,
      "ariaLabel": "Fravær i KMD Opus"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v("Fravær i KMD Opus")]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__person"
  }, [_c('strong', [_vm._v(_vm._s(_vm.userName || 'Ukendt'))]), _vm._v(" "), (_vm.employmentLabel) ? _c('span', {
    staticClass: "d-modal__person__employment"
  }, [_vm._v("· " + _vm._s(_vm.employmentLabel))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__subtitle"
  }, [_vm._v("\n          Viser fraværet, som det er registreret i KMD Opus lige nu. Data hentes direkte fra KMD, når vinduet åbnes, og når du klikker på Indlæs.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), (_vm.transfer) ? _c('div', {
    staticClass: "transfer-card"
  }, [_c('div', {
    staticClass: "transfer-card__title"
  }, [_vm._v("Valgt indberetning")]), _vm._v(" "), _c('div', {
    staticClass: "transfer-card__grid"
  }, [_c('div', {
    staticClass: "transfer-card__field"
  }, [_c('span', {
    staticClass: "transfer-card__label"
  }, [_vm._v("Fraværstype")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.transferTypeText || 'Ukendt'))])]), _vm._v(" "), _c('div', {
    staticClass: "transfer-card__field"
  }, [_c('span', {
    staticClass: "transfer-card__label"
  }, [_vm._v("Startdato")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.transferStartLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "transfer-card__field"
  }, [_c('span', {
    staticClass: "transfer-card__label"
  }, [_vm._v("Slutdato")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.transferEndLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "transfer-card__field"
  }, [_c('span', {
    staticClass: "transfer-card__label"
  }, [_vm._v("Dage")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.transfer.absence_days)))])]), _vm._v(" "), _c('div', {
    staticClass: "transfer-card__field"
  }, [_c('span', {
    staticClass: "transfer-card__label"
  }, [_vm._v("Timer")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDecimal(_vm.transfer.absence_hours)))])]), _vm._v(" "), _c('div', {
    staticClass: "transfer-card__field"
  }, [_c('span', {
    staticClass: "transfer-card__label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('span', [(_vm.transfer.state === 'error') ? _c('span', {
    staticClass: "status-pill status-pill--error"
  }, [_vm._v("Fejlet")]) : (_vm.transfer.state === 'ok') ? _c('span', {
    staticClass: "status-pill status-pill--ok"
  }, [_vm._v("Gennemført")]) : _c('span', {
    staticClass: "status-pill status-pill--pending"
  }, [_vm._v("Afventer")])])])]), _vm._v(" "), (_vm.transferMessages.length > 0) ? _c('div', {
    staticClass: "transfer-card__messages"
  }, [_c('span', {
    staticClass: "transfer-card__label"
  }, [_vm._v("Besked")]), _vm._v(" "), _vm._l((_vm.transferMessages), function(msg, idx) {
    return _c('span', {
      key: idx,
      class: {
        'message-error': msg.StatusType === 'E',
        'message-warning': msg.StatusType === 'W'
      }
    }, [_vm._v("\n          " + _vm._s(msg.MessageText) + "\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.matchStatus === 'match') ? _c('div', {
    staticClass: "transfer-card__result transfer-card__result--match"
  }, [_vm._v("\n        " + _vm._s(_vm.matchCount === 1 ? '1 tilsvarende post fundet i Opus' : _vm.matchCount + ' tilsvarende poster fundet i Opus') + ". Den er markeret med Match i tabellen.\n      ")]) : (_vm.matchStatus === 'other_type') ? _c('div', {
    staticClass: "transfer-card__result transfer-card__result--warning"
  }, [_vm._v("\n        Ingen post med samme type, men " + _vm._s(_vm.otherTypeOverlapCount) + " " + _vm._s(_vm.otherTypeOverlapCount === 1 ? 'overlappende post' : 'overlappende poster') + " med anden type: " + _vm._s(_vm.otherTypeOverlapCodes) + "\n      ")]) : (_vm.matchStatus === 'not_covered') ? _c('div', {
    staticClass: "transfer-card__result transfer-card__result--warning"
  }, [_vm._v("\n        Den valgte periode dækker ikke indberetningens datoer. Vælg en periode, der dækker " + _vm._s(_vm.transferStartLabel) + " - " + _vm._s(_vm.transferEndLabel) + ", og klik på Indlæs.\n      ")]) : (_vm.matchStatus === 'no_match') ? _c('div', {
    staticClass: "transfer-card__result transfer-card__result--none"
  }, [_vm._v("\n        Ingen tilsvarende post fundet i Opus\n      ")]) : (_vm.matchStatus === 'unknown_type') ? _c('div', {
    staticClass: "transfer-card__result transfer-card__result--warning"
  }, [_vm._v("\n        Indberetningens fraværstype kendes ikke, så der kan ikke søges efter en tilsvarende post i Opus.\n        "), (_vm.otherTypeOverlapCount > 0) ? [_vm._v("\n          " + _vm._s(_vm.otherTypeOverlapCount) + " " + _vm._s(_vm.otherTypeOverlapCount === 1 ? 'post' : 'poster') + " i Opus overlapper perioden: " + _vm._s(_vm.otherTypeOverlapCodes) + "\n        ")] : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-modal__toolbar"
  }, [_c('div', {
    staticClass: "d-modal__toolbar__filters"
  }, [_c('DoDatePickerRange', {
    attrs: {
      "allowSameDate": true,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "maximumDateRange": _vm.maximumDateRange,
      "dateShortCutsProps": _vm.dateShortCuts
    },
    on: {
      "startChanged": function($event) {
        _vm.startDate = $event
      },
      "endChanged": function($event) {
        _vm.endDate = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.readKmdAbsence
    }
  }, [_c('span', [_vm._v("Indlæs")])]), _vm._v(" "), (_vm.hasLoaded && !_vm.isLoading && _vm.isPeriodChanged) ? _c('span', {
    staticClass: "d-modal__hint"
  }, [_vm._v("\n          Perioden er ændret. Klik på Indlæs for at hente den fra KMD.\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.hasLoaded && !_vm.isLoading && !_vm.errorMessage) ? _c('span', {
    staticClass: "d-modal__count"
  }, [_vm._v("\n        " + _vm._s(_vm.rows.length) + " " + _vm._s(_vm.rows.length === 1 ? 'fraværsperiode' : 'fraværsperioder') + " · " + _vm._s(_vm.loadedPeriodLabel) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "d-modal__status"
  }, [_c('Loader', {
    attrs: {
      "isSmall": true
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "d-modal__progress"
  }, [_vm._v("Henter fravær fra KMD Opus…")])], 1) : (_vm.errorMessage) ? _c('div', {
    staticClass: "d-modal__error"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : (_vm.hasLoaded && _vm.rows.length === 0) ? _c('p', {
    staticClass: "d-modal__empty"
  }, [_vm._v("\n        Der er ikke registreret fravær i KMD Opus i perioden " + _vm._s(_vm.loadedPeriodLabel) + ".\n      ")]) : (_vm.hasLoaded) ? _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fraværstype")]), _vm._v(" "), _c('th', {
    staticClass: "td-date"
  }, [_vm._v("Startdato")]), _vm._v(" "), _c('th', {
    staticClass: "td-date"
  }, [_vm._v("Slutdato")]), _vm._v(" "), (_vm.hasTimes) ? _c('th', {
    staticClass: "td-time"
  }, [_vm._v("Tid")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Dage")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Timer")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Kalenderdage")]), _vm._v(" "), _c('th', {
    staticClass: "td-origin"
  }, [_vm._v("Oprettet i")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return _c('tr', {
      key: row.key,
      class: {
        'row--match': row.isMatch,
        'row--overlap': row.isOtherTypeOverlap
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(row.typeText || 'Ukendt fraværstype') + "\n            "), (row.typeCode) ? _c('span', {
      staticClass: "type-code"
    }, [_vm._v("(" + _vm._s(row.typeCode) + ")")]) : _vm._e(), _vm._v(" "), (row.isMatch) ? _c('span', {
      staticClass: "match-badge"
    }, [_vm._v("Match")]) : _vm._e(), _vm._v(" "), (row.isOtherTypeOverlap) ? _c('span', {
      staticClass: "overlap-badge"
    }, [_vm._v("Overlapper, anden type")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(row.vStartDate))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(row.vEndDate))]), _vm._v(" "), (_vm.hasTimes) ? _c('td', {
      staticClass: "td-time"
    }, [_vm._v(_vm._s(row.vTime))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.days)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.hours)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.calendarDays)))]), _vm._v(" "), _c('td', {
      staticClass: "td-origin"
    }, [(row.isFromDocendo) ? _c('span', {
      staticClass: "status-pill status-pill--docendo"
    }, [_vm._v("Oprettet i docendo")]) : _c('span', {
      staticClass: "status-pill status-pill--opus"
    }, [_vm._v("Oprettet i Opus")])])])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b4415f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/KmdOpusAbsenceModal.vue
// module id = 1988
// module chunks = 1